import React from "react";
import { Dropdown } from "semantic-ui-react";
import { useSelector } from "react-redux";

const User = () => {
  const user = useSelector((state) => state.nav.user);

  return (
    <Dropdown item text={user.name}>
      <Dropdown.Menu>
        <Dropdown.Item onClick={goToApplications} content="Applications" />
        <Dropdown.Item onClick={signOut} content="Sign Out" />
      </Dropdown.Menu>
    </Dropdown>
  );
};

const signOut = () => {
  const url = "https://doosanfuelcell.cloud/logout";
  window.location.assign(url);
};

const goToApplications = () => {
  const url = "https://doosanfuelcell.cloud/";
  window.location.assign(url);
};

export default User;
